import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=ff835842&"
import script from "./InsuranceList.vue?vue&type=script&lang=js&"
export * from "./InsuranceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports